import * as React from "react";
import {Box, Collapse, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {documentNumberChip, totalPill, unappliedAmountPill} from "./AccountingDocumentCells";
import {EmptyDocumentDetail, EmptyDocumentsTab} from "./DocumentsEmptyStates";

function documentCardDetail(row) {
    if (!row.hasApplications) {
        return <EmptyDocumentDetail label="Sin facturas imputadas — pago totalmente sin aplicar"/>;
    }
    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Número</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Moneda</TableCell>
                    <TableCell align="right">Monto Cancelado</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {row.applications.map((application, applicationIndex) =>
                    <TableRow key={applicationIndex}>
                        <TableCell>{application.numberWithPointOfSale}</TableCell>
                        <TableCell>{application.type}</TableCell>
                        <TableCell>{application.issueDate}</TableCell>
                        <TableCell>{row.currency}</TableCell>
                        <TableCell align="right">{totalPill(application.appliedAmount)}</TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    );
}

function AccountingDocumentCards({rows, emptyLabel, expandedRowIds, onToggleRow}) {
    if (rows.length === 0) {
        return <EmptyDocumentsTab label={emptyLabel}/>;
    }

    return (
        <Box>
            {rows.map(row => {
                const rowIsExpanded = expandedRowIds.has(row.id);
                return (
                    <Box key={row.id} sx={{border: '1px solid', borderColor: 'divider', borderRadius: 1, mb: 1, overflow: 'hidden'}}>
                        <Box onClick={() => onToggleRow(row.id)} sx={{
                            display: 'flex', alignItems: 'center', gap: 1.5, padding: '10px 12px', flexWrap: 'wrap',
                            backgroundColor: 'background.default', cursor: 'pointer',
                        }}>
                            <ChevronRightIcon fontSize="small" sx={{
                                color: 'text.disabled', flexShrink: 0, transition: 'transform .12s ease',
                                transform: rowIsExpanded ? 'rotate(90deg)' : 'none',
                            }}/>
                            {documentNumberChip(row.numberWithPointOfSale)}
                            <Typography variant="body2" color="text.secondary" whiteSpace="nowrap">Sapore Di Pane</Typography>
                            <Typography variant="body2" color="text.secondary" whiteSpace="nowrap">{row.emissionDate}</Typography>
                            <Typography variant="body2" color="text.secondary" whiteSpace="nowrap">{row.currency}</Typography>
                            <Box flex={1}/>
                            {row.hasUnappliedAmount && unappliedAmountPill(row.unappliedAmount)}
                            {totalPill(row.total)}
                        </Box>
                        <Collapse in={rowIsExpanded} timeout="auto" unmountOnExit>
                            {documentCardDetail(row)}
                        </Collapse>
                    </Box>
                );
            })}
        </Box>
    );
}

export default AccountingDocumentCards;
